import React , { useState , useEffect} from 'react';
import { Page, Icon, Link, List, ListGroup, ListItem } from 'framework7-react';
import axios from 'axios';
import { API_BASE_URL, API_AUTH } from './../globals';

const Notification = () =>{
  const [data ,setData] = useState([]);

  useEffect(() => {
    axios.get(API_BASE_URL + 'custnotification/id/'+localStorage.getItem('id'), {
        headers: {
          'Authorization': 'Basic ' + API_AUTH
        }
      })
      .then(response => setData(response.data))
      .catch(error => console.log(error));
  }, []);

  return (
    <Page className='bg-white'>
      <div className="container container-table ">
        <div className="row vertical-center-row col-md-12 col-md-offset-12">
          <header className="section-t-space">
            <div className="container-lg custom-container p-0">
              <div className="header-panel">
                <Link href="#" back><Icon ios="material:keyboard_arrow_left" aurora="material:keyboard_arrow_left" md="material:keyboard_arrow_left" className='theme-dark' backLink="Back" ></Icon></Link>
                <h2>Notifications</h2>
              </div>
            </div>
          </header>
          <section className="section-b-space  profile-form mt-3">
            <div className="custom-container p-0">
              <ul className="">
                {/* <div className='container p-0'> */}
                  <div className='row gy-3'>
                    { data.map((item , index) => (
                    <div className="bid-web-view-div">
                    <ul class="notifications-div">
                    {item.data !== item.date ?'' :item.date} 
                  {/* <div className={`vertical-product-box order-box ${item.noti_type === 1 ? 'bid-request-clr' : item.noti_type === 2 ? 'bid-review-clr' : item.noti_type === 3 ? 'bid-confirm-clr' :item.noti_type === 4 ? 'bid-delivery-clr':item.noti_type === 5 ? 'bid-canceled-clr':" "}`}> */}
                    <li class="notification-box unread">
                      {/* <div class="notification-icon">
                        <span>
                          <img class="notification-img img1" src="assets/images/svg/close.svg" alt="close"/>
                        </span>
                      </div> */}
                      <div class="notification-content">
                        <div className='notification-head'>
                            <div> <h5>{item.notification}</h5></div> 
                            <div><h6 >{item.date_time}</h6></div>   
                        </div>
                        <h6>{item.rest_name}</h6>
                        <p>{item.message.replace('[hotel_name]',item.rest_name).replace('[event_name]', item.event_name)}</p>                        
                      </div>
                    </li>
                    
                    {/* <div className="logo-notification">
                      <img className="img-fluid img" src={item.noti_type === 1 ? requestImage : item.noti_type === 2 ? feedbackImage : item.noti_type === 3 ? acceptImage :item.noti_type === 4 ? deliveredImage:item.noti_type === 5 ? cancelImage:" "} alt="vp1" />
                      </div>
                      <div className="vertical-box-details">
                      <div className="vertical-box-head">
                      <div className="restaurant d-flex justify-content-between col">
                      <h5 className="dark-text col-6">
                      {item.noti_type === 1 ? 'Bid Requested' : item.noti_type === 2 ? 'bid Reviewed' : item.noti_type === 3 ? 'bid Accepted' :item.noti_type === 4 ? 'bid Delivered':item.noti_type === 5 ? 'bid Delivered':" "}
                      </h5>
                      <h6 className="food-items text-black mb-2">{item.date_time}</h6>
                      </div>
                      <h6 className="food-items mb-2">{item.cust_name}
                      </h6>
                      </div>
                    </div> */}
                   {/* </div> */}
                   </ul>
                </div>
                    // <div className='bid-web-view-div'>
                    //   <li className="notification-box unread">
                    //   <div className="notification-icon">
                    //     <span>
                    //       <img className="notification-img img1" src="https://themes.pixelstrap.com/zomo-app/assets/images/svg/close.svg" alt="close" />
                    //     </span>
                    //   </div>
                    //   <div className="notification-content">
                    //     <h5 className={`notification-type ${item.notification_type.toLowerCase()}-clr`}>
                    //       {item.notification_type}
                    //     </h5>
                    //     <h6 className="date-time">{item.date_time}</h6>
                    //     <h6 className="restaurant-name">{item.rest_name}</h6>
                    //     Uncomment the below line if you have notification message 
                    //   <p>{item.notification_message}</p>
                    //   </div>
                    //   </li>
                    // </div>
                    ))}
                  </div>
                {/* </div> */}
                
                {/* <li className="notification-box unread">
                  <div className="notification-icon">
                    <span>
                      <img className="notification-img img1" src="https://themes.pixelstrap.com/zomo-app/assets/images/svg/close.svg" alt="close" />
                    </span>
                  </div>
                  <div className="notification-content">
                    <h5>Order Cancelled !!</h5>
                    <h6>Just Now huu</h6>
                    <p>Your order is cancelled due to some kitchen issues.i hope you understand this and thank you in advance for support us.</p>
                  </div>
                </li> */}

                {/* <li className="notification-box unread">
                  <div className="notification-icon">
                    <span>
                      <img className="notification-img img1" src={require("./../images/svg/add.svg").default} alt="add" />
                    </span>
                  </div>
                  <div className="notification-content">
                    <h5>New Service Available!</h5>
                    <h6>2 min ago</h6>
                    <p>You can make multiple food orders at one tile you can also cancel orders.</p>
                  </div>
                </li>
                <li className="notification-box">
                  <div className="notification-icon">
                    <span>
                      <img className="notification-img" src="assets/images/svg/money-tick.svg" alt="money-tick" />
                    </span>
                  </div>
                  <div className="notification-content">
                    <h5>Credit Card Connected</h5>
                    <h6>06:15 pm</h6>
                    <p>Your credit card successfully connected with foodfest.</p>
                  </div>
                </li>
                <li className="notification-box">
                  <div className="notification-icon">
                    <span>
                      <img className="notification-img" src="assets/images/svg/profile-circle.svg" alt="profile-circle" />
                    </span>
                  </div>
                  <div className="notification-content">
                    <h5>Account Successfully Updated</h5>
                    <h6>05:00 pm</h6>
                    <p>Your account is successfully updated, you can now experience our new service.</p>
                  </div>
                </li>
                <li className="notification-box">
                  <div className="notification-icon">
                    <span>
                      <img className="notification-img" src="assets/images/svg/discount-circle.svg" alt="discount-circle" />
                    </span>
                  </div>
                  <div className="notification-content">
                    <h5>New Offer</h5>
                    <h6>04:00 pm</h6>
                    <p>Flat 20% off on all type of pizza from any restaurant, #valid till 30 Nov, 2022.</p>
                  </div>
                </li> */}
              </ul>
            </div>
          </section>
        </div>
      </div>           
    </Page>
  );
}
export default Notification;
